import { localStorageWrapper } from '../../../../helpers/localStorage'
import { useGenerateCsvMutation } from '../mutations/useGenerateCsvMutation'
import { Button } from '@mui/material'
import { SendToMobile } from '@mui/icons-material'
import { useToast } from '../../../../contexts/ToastContext'

export const useGenerateCsvButton = (selectedPrescId: string | null) => {
  const generateCsvMutation = useGenerateCsvMutation()
  const { showToast } = useToast()

  const Button_ = selectedPrescId && (
    <div>
      {localStorageWrapper.getItem('show_save_csv_button') && (
        <Button
          variant="outlined"
          color="success"
          sx={{
            marginTop: 1,
            float: 'right',
          }}
          onClick={() => {
            generateCsvMutation.mutate(selectedPrescId, {
              onSuccess: () => {
                showToast('送信しました。', 'success')
              },
              onError: () => {
                showToast('送信できませんでした。', 'error')
              },
            })
          }}
          disabled={generateCsvMutation.isPending}
        >
          レセコンに送信
          <SendToMobile />
        </Button>
      )}
    </div>
  )

  return Button_
}
